export const VISIBLE_TIME_OUT = 300;
export const SIZES = {
    HEADER: "1450px",
    TABLET: '1024px',
    MOBILE: '768px',
};


export const SPECIAL_REQUIRED_REGEX = /[^a-z0-9]/i; // 특수문자 1개 이상
export const FIRST_CHAR_NUMBER_REGEX = /^[0-9]/;    // 첫 글자 숫자
export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "gif", "png"];

export const DEFAULT_ACCEPTS = [
    ".gif", ".jpg", ".jpeg", ".png",
    ".xls", ".xlsx", ".hwp", ".doc", ".docx",
    ".ppt", ".pptx", ".txt", ".pdf", ".hwpx",
];

